<template>
<div
	ref="form"
	class="row w-100 m-0 p-0 g-1"
	:class="{
		'row-cols-1 justify-content-end': layoutVertical,
		'justify-content-start flex-nowrap': layoutHorizontal,
	}"
>
	<div
		v-for="(tile, index) in renderTiles"
		:key="index"
		class="d-flex mt-0"
		:class="{
			'': index == 0 && layoutVertical,
			'col-auto': layoutHorizontal,
			'col mb-1 w-100': layoutVertical,
		}"
		:set="isArrows = forwardBackwardArrows && checkedIndex == index"
	>
		<button
			v-if="isArrows"
			type="button"
			class="btn btn-outline-secondary btn-sm"
			:class="{
				'': layoutHorizontal,
				'': layoutVertical,
				'': isArrows,
			}"
			:disabled="disabled"
			@click="goBackward()"
		>
			<button-icon icon="triangle-left" fill="currentColor" />
		</button>

		<input
			:id="`pick-period-${index}`"
			type="radio"
			class="btn-check"
			autocomplete="off"
			@click="onClickTile(tile, index)"
			:checked="index == checkedIndex"
			:disabled="disabled"
		>
		<label
			class="btn btn-outline-secondary btn-sm text-nowrap flex-fill overflow-x-hidden"
			:class="{
				'px-2': layoutHorizontal,
				'ms-1': layoutHorizontal && !isArrows && index > 0,
				'mx-1': isArrows,
			}"
			:for="`pick-period-${index}`"
		>
			{{ tile[0] }}
		</label>

		<button
			v-if="isArrows"
			type="button"
			class="btn btn-outline-secondary btn-sm w-auto"
			:class="{
				'': layoutHorizontal,
				'': layoutVertical,
				'': isArrows,
			}"
			:disabled="disabled || isForwardInFuture"
			@click="goForward"
		>
			<button-icon icon="triangle-right" fill="currentColor" />
		</button>
	</div>
</div>
</template>




<script>
import ButtonIcon from '@/components/Icons/ButtonIcon.vue'
import { useSizeBreakpoint } from '@/composables/size-breakpoint.js'
import {
	addSecondsToDate,
	dayStart,
	dayEnd,
} from '@/helpers.js'

export default {
	components: {
		ButtonIcon,
	},

	props: {
		// Array of arrays [tile_label, tile_value]
		tiles: {
			type: Array,
			required: false,
			default: new Array(
				['24 год', 1],
				['7 днів', 7],
				['30 днів', 30],
				['90 днів', 90],
				['1 рік', 365],
				['2 роки', 365 * 2],
				['5 років', 365 * 5],
			)
		},

		defaultTileIndex: {
			type: [Number, String],
			required: false,
			default: null
		},

		forwardBackwardArrows: {
			type: Boolean,
			required: false,
			default: false,
		},

		layout: {
			type: String, // 'horizontal', 'vertical'
			required: false,
			default: 'horizontal'
		},

		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
	},

	emits: {
		// One of tiles value
		value: null,
		// 
		currentTile: null,
		// returns: time_from:Date, time_to:Date, index:Number
		period: (v) => typeof v === 'object',
	},

	setup() {
		const { breakpoint } = useSizeBreakpoint()

		return {
			breakpoint,
		}
	},

	data() {
		return {
			// Now checked index for rendering
			checkedIndex: this.defaultTileIndex,
			timeForm: null,
			timeTo: null,
		}
	},

	created() {
		if (this.defaultTileIndex === null) {
			this.checkedIndex = 0
			// Preemit default checked value for external component rendering
			this.$emit('value', this.tiles[this.checkedIndex][1])
			this.$emit('currentTile', this.tiles[this.checkedIndex], this.checkedIndex)
		}

		this.setTimeFromTile()

		this.emitPeriod()
	},

	mounted() {},

	computed: {
		layoutVertical() {
			return this.layout == 'vertical'
		},

		layoutHorizontal() {
			return this.layout == 'horizontal'
		},

		renderTiles() {
			return (this.layoutHorizontal && ['None', 'sm'].includes(this.breakpoint))
				? this.tiles.slice(0, 4)
				: this.tiles
		},

		// If new time after click forward will be in the future
		isForwardInFuture() {
			return addSecondsToDate(this.timeTo, this.curentPeriodS).getTime() > new Date().getTime()
		},

		// Current period in seconds
		curentPeriodS() {
			return this.tiles[this.checkedIndex][1] * 24 * 60 * 60
		},
	},

	methods: {
		setTimeFromTile() {
			// For less reactivity in minute time range
			const nowDate = new Date()
			nowDate.setSeconds(59)
			nowDate.setMilliseconds(999)

			this.timeForm = this.tiles[this.checkedIndex][1] > 1
				? dayStart(addSecondsToDate(nowDate, this.curentPeriodS * -1))
				: addSecondsToDate(nowDate, this.curentPeriodS * -1)
			this.timeTo = dayEnd(nowDate)
		},

		onClickTile(tile, index) {
			this.checkedIndex = index

			this.$emit('value', tile[1])
			this.$emit('currentTile', tile, index)

			this.setTimeFromTile()

			this.emitPeriod()
		},

		goForward() {
			this.timeForm = dayStart(addSecondsToDate(this.timeForm, this.curentPeriodS))
			this.timeTo = dayEnd(addSecondsToDate(this.timeTo, this.curentPeriodS))

			this.emitPeriod()
		},

		goBackward() {
			this.timeForm = dayStart(addSecondsToDate(this.timeForm, this.curentPeriodS * -1))
			this.timeTo = dayEnd(addSecondsToDate(this.timeTo, this.curentPeriodS * -1))

			this.emitPeriod()
		},

		emitPeriod() {
			this.$emit('period',
				this.timeForm,
				this.timeTo,
				this.checkedIndex,
			)
		},
	}
}
</script>

